// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-options-box[data-v-eb9b6b0a]{box-shadow:0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -2px rgba(0,0,0,.05);top:2em}.edit-options-box[data-v-eb9b6b0a],.sticky-top[data-v-eb9b6b0a]{position:-webkit-sticky;position:sticky}.sticky-top[data-v-eb9b6b0a]{top:0}", ""]);
// Exports
module.exports = exports;
